import { Link } from 'react-router-dom';
import { SEO } from '../../seo/useSEO';
import { useStoreInfo } from '../../lib/appSettings';
import { t } from '../../i18n/pt';

export default function PrivacyPolicyPage(): JSX.Element {
  const storeInfo = useStoreInfo();
  const contactEmail = storeInfo.email || t.footer.contactEmail;

  return (
    <>
      <SEO title="Política de Privacidade" />
      <div className="container" style={{ maxWidth: 800 }}>
        <h1>Política de Privacidade</h1>
        <p>
          A Rosita Store respeita a tua privacidade e compromete-se a proteger os teus dados
          pessoais, em conformidade com o Regulamento Geral sobre a Proteção de Dados (RGPD) e a
          legislação portuguesa aplicável.
        </p>
        <h2>1. Responsável pelo tratamento</h2>
        <p>
          O responsável pelo tratamento dos teus dados é <strong>{storeInfo.name}</strong>
          {storeInfo.nif ? `, NIF ${storeInfo.nif}` : ''}
          {storeInfo.address ? `, com sede em ${storeInfo.address}` : ''}. Para qualquer questão
          relacionada com os teus dados pessoais, escreve para{' '}
          <a href={`mailto:${contactEmail}`}>{contactEmail}</a>. A identificação completa está nos{' '}
          <Link to="/termos-e-condicoes#identificacao">Termos e Condições</Link>.
        </p>
        <h2>2. Dados recolhidos</h2>
        <p>
          Recolhemos apenas os dados necessários para processar as tuas encomendas: nome, e-mail,
          morada, telefone e NIF (opcional, para fatura).
        </p>
        <h2>3. Finalidades</h2>
        <p>
          Os teus dados são utilizados para processar encomendas, emitir faturas, comunicar o
          estado dos envios e cumprir obrigações legais.
        </p>
        <h2>4. Direitos do titular</h2>
        <p>
          Tens direito a acederes, corrigires, eliminares ou limitares o tratamento dos teus
          dados. Escreve-me para exercer qualquer um destes direitos.
        </p>
        <h2>5. Cookies</h2>
        <p>
          O site utiliza apenas cookies essenciais por defeito. Cookies opcionais só são ativados
          depois de dares o teu consentimento.
        </p>
      </div>
    </>
  );
}
